module.exports = __webpack_public_path__ + "img/tracking.e8f07b1f.svg";